// extracted by mini-css-extract-plugin
export default {"main":"modal_main__P36m8","btn":"modal_btn__rYofD"};